import Scrollbar from './scrollBar';

export default Scrollbar;